import { Pipe, PipeTransform } from '@angular/core';

import { Région } from '../../administration/gestion-sites/model/région.model';
import { ÉTAT_GROUPE, étatGroupeOrdre } from '../../offre-regionale/enum/état-groupe.enum';

@Pipe({
  name: 'getEtatRegion',
})
export class GetEtatRegionPipe implements PipeTransform {
  transform(région: Région): ÉTAT_GROUPE {
    const groupes = région.sites.flatMap((x) => x.etapes).flatMap((x) => x.groupes ?? []);
    if (!groupes.length) return ÉTAT_GROUPE.A_FAIRE;

    return groupes
      .map((x) => x.etat)
      .reduce((min, current) => (étatGroupeOrdre[current] < étatGroupeOrdre[min] ? current : min));
  }
}
